import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserDetailsService } from 'src/app/onelog/services/user-details.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {
  constructor(
    private userDetailsService: UserDetailsService,
    private router: Router
  ) {}

  logout() {
    this.userDetailsService.destoryUserDetails();
    this.router.navigate(['/login']);
  }
}
